import axiosInstance from './axiosInstance';
import { ApiResponse } from './types';

export const getSimilarDates = async (
	property_id: string,
	params: {}
): Promise<ApiResponse<any[]>> => {
	const response = await axiosInstance.get(
		`/v2/p/${property_id}/opx/get-similar-dates`,
		{
			params,
		}
	);
	return response.data;
};

export const getMeanHalfHourlyDemand = async (
	property_id: string,
	params: {}
): Promise<ApiResponse<any[]>> => {
	const response = await axiosInstance.get(
		`/v2/p/${property_id}/opx/get-half-hourly-mean-data`,
		{
			params,
		}
	);
	return response.data;
};

export const getHistoricalConsumptionData = async (
	property_id: string,
	params: {}
): Promise<ApiResponse<any[]>> => {
	const response = await axiosInstance.get(
		`/v2/p/${property_id}/opx/get-historical-consumption-data`,
		{ params }
	);
	return response.data;
};

export const getAggregatedWeather = async (
	property_id: string,
	date: string,
	weather_location_id: string,
	aggregationType: string
): Promise<ApiResponse<any[]>> => {
	const response = await axiosInstance.get(
		`/v2/p/${property_id}/opx/get-aggregated-weather-data`,
		{
			params: {
				end_date: date,
				weather_location_id: weather_location_id,
				aggregation_type: aggregationType,
			},
		}
	);
	return response.data;
};

export const getSystemAnalysis = async (
	propertyId: string
): Promise<ApiResponse<any>> => {
	const response = await axiosInstance.get(
		`/v2/p/${propertyId}/opx/get-system-analysis`
	);
	return response.data;
};

export const getSetpointRecommendation = async (
	property_id: string
): Promise<ApiResponse<any[]>> => {
	const response = await axiosInstance.get(
		`/v2/p/${property_id}/opx/setpoint-recommendation`
	);
	return response.data;
};
export const getFaultsOverview = async (
	property_id: string
): Promise<ApiResponse<any[]>> => {
	const response = await axiosInstance.get(
		`/v2/p/${property_id}/opx/faults-overview`
	);
	return response.data;
};

export const getFilteredFaults = async (
	property_id: string,
	page: number,
	page_size: number
): Promise<ApiResponse<any[]>> => {
	const response = await axiosInstance.get(
		`/v2/p/${property_id}/opx/get-filtered-faults`,
		{
			params: {
				page: page,
				page_size: page_size,
			},
		}
	);
	return response.data;
};

export const getFaultDetails = async (
	property_id: string,
	fault_topic_id: string
): Promise<ApiResponse<any[]>> => {
	const response = await axiosInstance.get(
		`/v2/p/${property_id}/opx/fault-details/${fault_topic_id}`
	);
	return response.data;
};

export const getFaultChartData = async (
	property_id: string,
	fault_topic_id: string,
	interval: string
): Promise<ApiResponse<any[]>> => {
	const response = await axiosInstance.get(
		`/v2/p/${property_id}/opx/fault-chart-data`,
		{
			params: {
				fault_topic_id: fault_topic_id,
				interval: interval,
			},
		}
	);
	return response.data;
};

export const getCompareChartData = async (
	property_id: string,
	fault_topic_id: string,
	interval: string
): Promise<ApiResponse<any[]>> => {
	const response = await axiosInstance.get(
		`/v2/p/${property_id}/opx/fault-compare-chart-data`,
		{
			params: {
				fault_topic_id: fault_topic_id,
				interval: interval,
			},
		}
	);
	return response.data;
};

export const getOpxECMRecommendations = async (
	property_id: string
): Promise<ApiResponse<any[]>> => {
	const response = await axiosInstance.get(
		`/v2/p/${property_id}/opx/opx-ecm-recommendations`
	);
	return response.data;
};
